import { render, staticRenderFns } from "./AddProjectDialog.vue?vue&type=template&id=23014db8&"
import script from "./AddProjectDialog.vue?vue&type=script&lang=js&"
export * from "./AddProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports